// extracted by mini-css-extract-plugin
export default {"m":"_9f64cda9d8","title":"d02f60a28c","feedback_inner_title":"d31142d879","textarea":"_975ef05692","radio":"dda39dc032","text":"_4446fafcec"};